var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 68,
    viewBox: "0 0 84 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "next",
    transform: "translate(-924 -4261)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5951",
    "data-name": "Rectangle 5951",
    width: 84,
    height: 68,
    rx: 12,
    transform: "translate(924 4261)",
    fill: "#e5f1fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4043",
    "data-name": "Path 4043",
    d: "M18.416,24a2.086,2.086,0,0,1-1.479-.61L9.4,15.895q-.065-.064-.123-.133L1.031,7.551a2.069,2.069,0,0,1,0-2.941,2.1,2.1,0,0,1,2.96,0L18.417,18.953,32.843,4.608a2.1,2.1,0,0,1,2.96,0,2.068,2.068,0,0,1,0,2.943l-8.238,8.2q-.063.075-.133.145L19.9,23.388a2.091,2.091,0,0,1-1.479.61Z",
    transform: "translate(947.582 4281.002)",
    fill: "#0078d7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.4afcdd030f563c6a376d5d0e0165c1f7.svg";
export { ForwardRef as ReactComponent };